/* @ngInject */
function angularConfig(
  $locationProvider,
  $httpProvider,
  $compileProvider,
  $provide,
  NotificationProvider,
  $qProvider,
  notificationsConfigProvider,
  localStorageServiceProvider,
  tmhDynamicLocaleProvider
) {
  /**
   * Disable debug info on prod mode
   */
  if (process.env.ENV === "prod") $compileProvider.debugInfoEnabled(false);

  /**
   * IE Caching Issue
   */
  if (!$httpProvider.defaults.headers.get)
    $httpProvider.defaults.headers.get = {};
  $httpProvider.defaults.headers.get["If-Modified-Since"] =
    "Mon, 26 Jul 1997 05:00:00 GMT";
  $httpProvider.defaults.headers.get["Cache-Control"] = "no-cache";
  $httpProvider.defaults.headers.get.Pragma = "no-cache";

  /**
   * Enable HTML5 Mode
   */
  $locationProvider.html5Mode(true);

  /**
   * Register interceptors
   */
  $httpProvider.interceptors.push("AuthenticationInterceptor");
  $httpProvider.interceptors.push("UnauthorizedInterceptor");
  // $httpProvider.interceptors.push('ImpersonateInterceptor');
  $httpProvider.interceptors.push("PlanLimitExceedInterceptor");
  $httpProvider.interceptors.push("ErrorInterceptor");

  /**
   * UI Notification Global Settings
   */
  NotificationProvider.setOptions({ startTop: 100 });

  /**
   * ngNotificationsBar Provider
   */
  notificationsConfigProvider.setAutoHide(true);
  notificationsConfigProvider.setHideDelay(3000);
  notificationsConfigProvider.setAcceptHTML(false);
  notificationsConfigProvider.setAutoHideAnimation("fadeOutNotifications");
  notificationsConfigProvider.setAutoHideAnimationDelay(1200);

  /**
   * Local Storage
   */
  localStorageServiceProvider.setPrefix("quoters");

  /**
   *
   */
  tmhDynamicLocaleProvider.localeLocationPattern(
    "https://code.angularjs.org/1.7.9/i18n/angular-locale_{{locale}}.js"
  );

  $qProvider.errorOnUnhandledRejections(false);
}

export default angularConfig;
